import companyTrends from './company-trends'
import companyUser from './company-user'
import trendoneUniverse from './trendone-universe'

export default {
    title: 'Welcome to the admin backend of the Trendmanager',
    pageTitle: 'ADMIN - HOME',
    companyTrends,
    companyUser,
    trendoneUniverse
}
